import { render, staticRenderFns } from "./DeviseTable.vue?vue&type=template&id=8ed03112&"
import script from "./DeviseTable.vue?vue&type=script&lang=js&"
export * from "./DeviseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports